import { createAsyncThunk } from "@reduxjs/toolkit";

import { CachePolicy } from "api/types";
import { JANZU_URL } from "config/config";

interface GetApiIdentitiesArgs {
  pageSize?: number;
  page?: number; // 1-indexed DRF page number; omit or pass 1 for first page
  ordering?: string;
  search?: string;
  includeRevoked?: boolean;
}

/** Fetch the current user's ApiIdentity list from device-api. */
export const getApiIdentities = createAsyncThunk(
  "apiIdentities/getApiIdentities",
  async (args?: GetApiIdentitiesArgs) => {
    const params = new URLSearchParams();
    params.set("page_size", String(args?.pageSize ?? 25));
    params.set("ordering", args?.ordering ?? "-created_at");
    if (args?.search) {
      params.set("search", args.search);
    }
    if (args?.page && args.page > 1) {
      params.set("page", String(args.page));
    }
    if (args?.includeRevoked) {
      params.set("include_revoked", "true");
    }
    const fetchUrl = `${JANZU_URL}device-api/api-identities?${params.toString()}`;

    const response = await fetch(fetchUrl, {
      headers: {
        "Cache-Control": CachePolicy.NO_CACHE,
        Pragma: CachePolicy.NO_CACHE,
      },
    });
    if (response.ok) {
      return response.json();
    }
    throw new Error("Failed to fetch api identities");
  }
);
